import { render, staticRenderFns } from "./SglBed.vue?vue&type=template&id=58424b88"
import script from "./SglBed.vue?vue&type=script&lang=js"
export * from "./SglBed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports